export default "__VITE_ASSET__6ad4f4e7__"